import { RefObject, useEffect, useState } from 'react';

interface IUseElementFullyScrolled {
  isFullyScrolled: boolean;
}

interface IUseElementFullyScrolledOptionsProp {
  scrollOffset?: number;
}

export const useElementFullyScrolled = <T extends HTMLElement>(
  ref: RefObject<T>,
  options?: IUseElementFullyScrolledOptionsProp
): IUseElementFullyScrolled => {
  const [isFullyScrolled, setIsFullyScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const { scrollTop, scrollHeight, clientHeight } = ref.current;
        setIsFullyScrolled(
          scrollTop + clientHeight >=
            scrollHeight - (options?.scrollOffset ?? 10)
        );
      }
    };

    if (ref.current) {
      ref.current.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (ref.current) {
        ref.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return { isFullyScrolled };
};
